import { Market, SportMatchModel } from '@nf/types/odds';
import { OddsButton } from '@/components/widgets/odds-button';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { betTypeService } from '@/services/bettype.service';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { specialGroupBySliceResourceIdBetTypes } from '@/settings/bet-type-settings';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeCol3GoalFromOdds = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();

	const t = useTranslations('General');

	const { user } = useAccountInfo();
	const oddsData = useAtomValue(oddsPageAtom);

	const betTypeId = betTypeArray[0].BetTypeId;
	const { betChoices, betChoiceTranslateType } = getBetTypeSetting(betTypeId, matchModel.GameID);

	const sortedBetTypeArray =
		matchModel?.GameID === 43 ? betTypeArray.sort((a, b) => {
			if (a.sort != b.sort) {
				return a.sort - b.sort;
			} else {
				return Number(a.Line) - Number(b.Line);
			}
		}) : betTypeArray.sort((a, b) => {
			if (a.sort != b.sort) {
				return a.sort - b.sort;
			} else {
				return Number(a.Resourceid.slice(2, 4)) - Number(b.Resourceid.slice(2, 4));
			}
		});

	const getDisplayLine = (market: Market) => {
		if (specialGroupBySliceResourceIdBetTypes.includes(betTypeArray[0].BetTypeId)) {
			return Number(market.Resourceid.substring(2, 4));
		}
		const betTypeId = market.BetTypeId;
		const basketballSpecialBetType = [606, 607, 613];
		return basketballSpecialBetType.includes(betTypeId) ? market.Resourceid : market.Line;
	}

	return (
		<div className="bettype__content bettype__content--col-3-goal">
			<div className="bettype__list">
				<div className="bettype__goal" />
				{
					betChoices.map((choice) => {
						let title;
						const teamName = betTypeService.getBetChoiceDisplayTeamName(betTypeId, choice.betTeam, matchModel, t('Neutral_Team'), oddsData?.teamNameMap);
						if (teamName) {
							title = teamName;
						} else if (betChoiceTranslateType) {
							title = t(choice.label);
						} else {
							title = choice.label;
						}

						return <div key={choice.betTeam} className="bettype__title">{title}</div>;
					})
				}
			</div>
			{
				sortedBetTypeArray.map((market) => {
					return (
						<div key={`${market.Line}_${market.MarketId}`} className="bettype__list">
							<div className="bettype__goal">{getDisplayLine(market)}</div>
							{
								betChoices.map((choice) => {
									return (
										<OddsButton
											key={`${market.Line}_${choice.betTeam}`}
											match={matchModel as SportMatchModel}
											market={market}
											selection={market.Selections[choice.betTeam]}
											homeTeamName={''}
											awayTeamName={''}
											variant="default"
											betTeam={market.Selections[choice.betTeam].SelId}
											originalPrice={market.Selections[choice.betTeam].Price}
											sport={matchModel?.GameID}
											type="OU"
											oddsType={user?.OType}
											accountStatus={user?.ActStatus ?? 0}
										/>
									)
								})
							}
						</div>
					)
				})
			}
		</div>
	)
};
